import { filter, values, isEmpty, pipe, length, lt } from 'ramda';

export const hasAnyEmptyField = pipe(
  values,
  filter(isEmpty),
  length,
  lt(0)
);
